module.exports = __webpack_public_path__ + "static/img/tianmao.9f61406.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pc/tianmao.jpg
// module id = FZ/u
// module chunks = 18